import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-profile-confirm-close-modal',
    templateUrl: './profile-confirm-close-modal.component.html',
    styleUrls: ['./profile-confirm-close-modal.component.css']
})
export class ProfileConfirmCloseModalComponent {
    constructor(public activeModal: NgbActiveModal) { }

    confirm() {
        this.activeModal.close(true);
    }

    cancel() {
        this.activeModal.dismiss(false);
    }
}

